const Metrics = ({ metricData }) => {
  if (!metricData) return null;
  const { name, icon, value } = metricData;

  return (
    <div className="metric-tile">
      <div className="icon">{icon}</div>
      <span>{value}</span>
      <p>{name}</p>
    </div>
  );
};

export default Metrics;
